import { Link } from 'react-router-dom';
import { useConfiguration, useLocale } from '@gov-nx/core/service';
import { useDataBoxMessageFormContext } from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button, Dialog, Icon } from '@gov-nx/ui/web';

export const LowCreditPrompt = () => {
	const { t: tn } = useLocale(PageCode['datove-schranky']);

	const { lowCreditPrompt, messagePrice } = useDataBoxMessageFormContext();
	const { datovaSchrankaDobitiKredituUrl } = useConfiguration();

	return (
		<Dialog
			isOpen={lowCreditPrompt.isOpen}
			onClose={lowCreditPrompt.handleClose}
			title={<h3>{tn('nova-zprava.je-potreba-dobit-kredit')}</h3>}
			footer={
				<>
					<Button
						color="primary"
						nativeType="button"
						type="base"
						size="m"
						onClick={lowCreditPrompt.handleClose}
						aria-label={tn('kredit.wcag.zrusit')}>
						{tn('nova-zprava.nepridavat-adresata')}
					</Button>
					<Button
						asChild
						color="primary"
						type="solid"
						size="m"
						iconStart={
							<Icon
								type="components"
								name="box-arrow-up-right"
							/>
						}
						aria-label={tn('kredit.wcag.prejit')}>
						<Link
							to={datovaSchrankaDobitiKredituUrl.replace(
								'{{DS_ID}}',
								lowCreditPrompt.senderId as string
							)}
							target="_blank">
							{tn('nova-zprava.prejit-na-dobiti')}
						</Link>
					</Button>
				</>
			}>
			<p>
				{tn('nova-zprava.je-potreba-dobit-kredit-vysvetleni', {
					price: messagePrice.formattedPrice,
				})}
			</p>
		</Dialog>
	);
};
